export default __webpack_public_path__ + "static/media/bardo.ee474f4b.png";